import { Box } from '@chakra-ui/react'
import EEFCTable from './component/EEFCTable/EEFCTable'

const EEFCRegister = () => {
  return (
    <Box>
      <EEFCTable/>
    </Box>
  )
}

export default EEFCRegister